import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=3cbfb046&scoped=true"
import script from "./DetailOrder.vue?vue&type=script&lang=js"
export * from "./DetailOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbfb046",
  null
  
)

export default component.exports